module.exports = __webpack_public_path__ + "img/scene.51a2fb60.svg";